var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.23 7.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.22,7.3v-1.04H1.4V1.36l-1.4,.19V.71L1.84,.12h.86V6.26h1.18v1.04H.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.91,3.95c-.6,.63-1.25,.78-1.78,.78-1.35,0-2.17-.87-2.17-2.28S5.94,0,7.53,0c1.71,0,2.7,1.23,2.7,3.36s-1.04,4.06-3.05,4.06c-.76,0-1.44-.19-2.04-.65l.6-.96c.47,.4,.91,.55,1.42,.55,1.1,0,1.7-.98,1.77-2.41h-.02Zm-1.38-2.91c-.79,0-1.28,.55-1.28,1.38s.46,1.26,1.25,1.26c.59,0,1.17-.41,1.39-.97,0-.94-.46-1.67-1.36-1.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19);
export default __webpack_public_path__ + "static/media/19.7ee50eb776d27f5c605139e33b791abe.svg";
export { ForwardRef as ReactComponent };